<template>
  <v-dialog
    :value="openAddPausas"
    max-width="600px"
    persistent
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">{{ edit ? 'Editar' : 'Criar' }} Pausa</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:openAddPausas', false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <v-text-field
            v-model="pausaData.nome"
            outlined
            dense
            :rules="[validators.required]"
            label="Nome"
            placeholder="Nome"
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <v-textarea
            v-model="pausaData.descricao"
            :rules="[validators.required]"
            outlined
            dense
            auto-grow
            label="Descrição"
            placeholder="Descrição"
            hide-details="auto"
            class="mb-6"
          ></v-textarea>

          <v-text-field
            v-model="pausaData.tempo"
            v-mask="'##:##'"
            label="Tempo (HH:mm)"
            outlined
            dense
            hide-details="auto"
            placeholder="Tempo (HH:mm)"
            class="mb-6"
            @input="onInput"
          >
          </v-text-field>

          <v-checkbox
            v-model="pausaData.bloquearTela"
            :label="`Bloquear Tela`"
          ></v-checkbox>

          <div
            class="d-flex justify-center"
          >
            <v-btn
              color="primary"
              class="me-3 mb-1"
              type="submit"
            >
              <v-progress-circular
                v-if="loadings"
                class="mx-6"
                indeterminate
                color="secundary"
              ></v-progress-circular>
              <span v-else> {{ edit ? 'Editar' : 'Criar' }} </span>
            </v-btn>
            <v-btn
              color="secondary"
              class="mb-1"
              outlined
              type="reset"
              @click="$emit('update:openAddPausas', false)"
            >
              Cancelar
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { nameValidator, required } from '@core/utils/validation'
import { mdiClose, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import PausasService from '@/services/modules/PausasService'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: Object,
      required: null,
    },
    openAddPausas: {
      type: Boolean,
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    onInput(value) {
      const cleanedValue = value.replace(/\D/g, '')
      if (cleanedValue.length === 4) {
        const hours = parseInt(cleanedValue.slice(0, 2), 10)
        const minutes = parseInt(cleanedValue.slice(2, 4), 10)

        if (hours <= 23 && minutes <= 59) {
          const formattedValue = cleanedValue.replace(/(\d{2})(\d{2})/, '$1:$2')
          this.selectedTime = formattedValue
        } else {
          this.pausaData.tempo = ''
        }
      } else {
        this.pausaData.tempo = cleanedValue
      }
    },
  },

  setup(props, { emit }) {
    const blankpausaData = {
      nome: '',
      descricao: '',
      tempo: '',
      bloquearTela: true,
    }

    const valid = ref(false)
    const form = ref(null)

    const loadings = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const pausaData = ref(blankpausaData)
    const errorMsg = ref('Entre em contato com o servidor.')
    const resetpausaData = () => {
      pausaData.value = JSON.parse(JSON.stringify(blankpausaData))
      resetForm()

      emit('update:openAddPausas', false)
    }

    watch(
      () => props.data,
      () => {
        pausaData.value = {
          nome: props.data.nome,
          descricao: props.data.descricao,
          tempo: props.data.tempo,
          bloquearTela: props.data.bloquearTela,
        }
      },
    )

    watch(
      () => props.openAddPausas,
      () => {
        if (!props.openAddPausas) {
          pausaData.value = JSON.parse(JSON.stringify(blankpausaData))
        }
      },
    )

    const onSubmit = async () => {
      if (valid.value) {
        loadings.value = true
        pausaData.value.tempo = pausaData.value.tempo.replace(/:/g, '')

        const { length } = pausaData.value.tempo

        if (length < 4) {
          pausaData.value.tempo = pausaData.value.tempo.padStart(4, '0')
        }

        const hours = parseInt(pausaData.value.tempo.slice(0, 2), 10)
        const minutes = parseInt(pausaData.value.tempo.slice(2, 4), 10)

        if (hours <= 23 && minutes <= 59) {
          const totalMinutes = hours * 60 + minutes
          pausaData.value.tempo = totalMinutes.toString()
        } else {
          pausaData.value.tempo = null
        }

        try {
          if (props.edit) {
            PausasService.atualizar(props.data.id, pausaData.value)
          } else {
            PausasService.criar(pausaData.value)
          }

          loadings.value = false
          emit('refetch-data')
          emit('update:openAddPausas', false)
        } catch {
          loadings.value = false
        }
      }
      validate()
    }

    return {
      resetpausaData,
      onSubmit,
      validate,
      form,
      pausaData,
      valid,
      blankpausaData,
      loadings,
      errorMsg,

      // validation
      validators: {
        required,
        nameValidator,
      },
      icons: {
        mdiClose,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>
